import { getStateCity } from "../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const list_stateCityThunk = createAsyncThunk(
  "list_stateCityThunk",
  async ({ params, token }) => {
    try {
      const response = getStateCity(params, token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
